import React from "react";
import style from "./TableDatiUtente.module.css"
import Utils from "../../utils/Utils";
import styles from "../table/Table.module.css";
import OggettiUtili from "../../utils/OggettiUtili.json"

export default class TableDatiUtente extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {

        return (
            <div>
                <table id={"tabDatiUtente"} className={style.table}>
                    <tr>
                        <th className={style.testoDenominazione}>ID Segnalazione</th>
                        <th className={style.testoDenominazione}>Cognome e Nome</th>
                        <th className={style.testoDenominazione}>Data di Nascita</th>
                        <th className={style.testoDenominazione}>Malattia</th>
                        <th className={style.testoDenominazione}>Stato Segnalazione</th>
                    </tr>
                    <tr>
                        <td className={style.testo}>
                            {this.props.idSegnalazione}
                        </td>
                        <td className={style.testo}>
                            {this.props.datiUtente.cognomePaziente && this.props.datiUtente.nomePaziente ? this.props.datiUtente.cognomePaziente + " " + this.props.datiUtente.nomePaziente : ""}
                        </td>
                        <td className={style.testo}>
                            {this.props.datiUtente.dataDiNascita}
                        </td>
                        <td className={style.testo}>
                            {Utils.mapMalattie(this.props.datiUtente.malattia)}
                        </td>
                        <td className={style.testo} style={{minWidth:"150px"}}>
                            <div className={"row"} style={{justifyContent:"center",alignItems:"center"}}>
                                <div className={"col-8"}>
                                    {OggettiUtili.statoSegnalazione[this.props.statoSegnalazione].sNome}
                                </div>
                                <div className={"col-2"}>
                                    <div className={styles[OggettiUtili.statoSegnalazione[this.props.statoSegnalazione].cssClass]} />
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        );
    }

}
